import React from 'react'
import { IconProps } from '../types'

export default function TranscriptIcon({
    className = 'h-4 w-4',
    fill = 'currentColor',
    ...props
}: IconProps) {
    return (
        <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <g clipPath="url(#clip0_12352_2058)">
                <path
                    d="M3.75 12C3.75 11.8011 3.82902 11.6103 3.96967 11.4697C4.11032 11.329 4.30109 11.25 4.5 11.25H10.5C10.6989 11.25 10.8897 11.329 11.0303 11.4697C11.171 11.6103 11.25 11.8011 11.25 12C11.25 12.1989 11.171 12.3897 11.0303 12.5303C10.8897 12.671 10.6989 12.75 10.5 12.75H4.5C4.30109 12.75 4.11032 12.671 3.96967 12.5303C3.82902 12.3897 3.75 12.1989 3.75 12ZM13.5 8.25C13.6989 8.25 13.8897 8.32902 14.0303 8.46967C14.171 8.61032 14.25 8.80109 14.25 9C14.25 9.19891 14.171 9.38968 14.0303 9.53033C13.8897 9.67098 13.6989 9.75 13.5 9.75H7.5C7.30109 9.75 7.11032 9.67098 6.96967 9.53033C6.82902 9.38968 6.75 9.19891 6.75 9C6.75 8.80109 6.82902 8.61032 6.96967 8.46967C7.11032 8.32902 7.30109 8.25 7.5 8.25H13.5ZM12 12C12 11.8011 12.079 11.6103 12.2197 11.4697C12.3603 11.329 12.5511 11.25 12.75 11.25H13.5C13.6989 11.25 13.8897 11.329 14.0303 11.4697C14.171 11.6103 14.25 11.8011 14.25 12C14.25 12.1989 14.171 12.3897 14.0303 12.5303C13.8897 12.671 13.6989 12.75 13.5 12.75H12.75C12.5511 12.75 12.3603 12.671 12.2197 12.5303C12.079 12.3897 12 12.1989 12 12ZM5.25 8.25C5.44891 8.25 5.63968 8.32902 5.78033 8.46967C5.92098 8.61032 6 8.80109 6 9C6 9.19891 5.92098 9.38968 5.78033 9.53033C5.63968 9.67098 5.44891 9.75 5.25 9.75H4.5C4.30109 9.75 4.11032 9.67098 3.96967 9.53033C3.82902 9.38968 3.75 9.19891 3.75 9C3.75 8.80109 3.82902 8.61032 3.96967 8.46967C4.11032 8.32902 4.30109 8.25 4.5 8.25H5.25Z"
                    fill={fill}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 2.25C2.40326 2.25 1.83097 2.48705 1.40901 2.90901C0.987053 3.33097 0.75 3.90326 0.75 4.5V13.5C0.75 14.0967 0.987053 14.669 1.40901 15.091C1.83097 15.5129 2.40326 15.75 3 15.75H15C15.5967 15.75 16.169 15.5129 16.591 15.091C17.013 14.669 17.25 14.0967 17.25 13.5V4.5C17.25 3.90326 17.013 3.33097 16.591 2.90901C16.169 2.48705 15.5967 2.25 15 2.25H3ZM15 3.75H3C2.80109 3.75 2.61032 3.82902 2.46967 3.96967C2.32902 4.11032 2.25 4.30109 2.25 4.5V13.5C2.25 13.6989 2.32902 13.8897 2.46967 14.0303C2.61032 14.171 2.80109 14.25 3 14.25H15C15.1989 14.25 15.3897 14.171 15.5303 14.0303C15.671 13.8897 15.75 13.6989 15.75 13.5V4.5C15.75 4.30109 15.671 4.11032 15.5303 3.96967C15.3897 3.82902 15.1989 3.75 15 3.75Z"
                    fill={fill}
                />
            </g>
            <defs>
                <clipPath id="clip0_12352_2058">
                    <rect width="18" height="18" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}
